export const JOB_STATUS = {
  FAILED: '-1',
  PENDING: '0',
  PRINTING: '1',
  PACKING: '2',
  CHECKING: '3',
  DELIVERY: '4',
  CORRECT: '5',
  COMPLETED: '6',
  CREATED: '7',
  UNDO: '8',
};

export const HEADER_VALUE = {
  ALL_JOBS: 'ALL_JOBS',
  PENDING: JOB_STATUS.PENDING,
  PRINTING: JOB_STATUS.PRINTING,
  PACKING: JOB_STATUS.PACKING,
  CHECKING: JOB_STATUS.CHECKING,
  DELIVERY: JOB_STATUS.DELIVERY,
  CORRECT: JOB_STATUS.CORRECT,
  COMPLETED: JOB_STATUS.COMPLETED,
  UNDO: JOB_STATUS.UNDO,
};

export const CHECKING_STATUS = {
  PENDING: '0',
  PASSED: '1',
  FAILED_AS_INCORRECT_DRUG: '2',
  FAILED_AS_INCORRECT_QUALITY: '3',
  FAILED_AS_SPECIFIC_REASON: '4',
};

export const CHECKING_LABEL_MAP = {
  [CHECKING_STATUS.FAILED_AS_INCORRECT_DRUG]: 'REJECT_MODAL_OPTION_INCORRECT_DRUG',
  [CHECKING_STATUS.FAILED_AS_INCORRECT_QUALITY]: 'REJECT_MODAL_OPTION_INCORRECT_QTY',
  [CHECKING_STATUS.FAILED_AS_SPECIFIC_REASON]: 'REJECT_MODAL_OPTION_OTHER',
};

export const DISTRIBUTE_STATUS = {
  PICKUP: '0',
  DELIVERY: '1',
};

export const DISTRIBUTION_LABEL_MAP = {
  [DISTRIBUTE_STATUS.PICKUP]: 'DISTRIBUTION_PICK_UP',
  [DISTRIBUTE_STATUS.DELIVERY]: 'DISTRIBUTION_DELIVERY',
};

export const FILTER_PACK_ALL = 'FILTER_PACK_ALL';

export const MAX_PACK_SIZE = 8;

export const CREATED_DATE = {
  ALL: 'ALL',
  LAST_7: 'LAST_7',
  LAST_14: 'LAST_14',
  LAST_30: 'LAST_30',
  LAST_60: 'LAST_60',
};

export const DEFAULT_CREATED_DATE_VALUE = {
  [CREATED_DATE.ALL]: null,
  [CREATED_DATE.LAST_7]: 7,
  [CREATED_DATE.LAST_14]: 14,
  [CREATED_DATE.LAST_30]: 30,
  [CREATED_DATE.LAST_60]: 60,
};

export const CREATED_DATE_OPTIONS = [
  { label: 'All', value: CREATED_DATE.ALL },
  { label: 'Last 7 days', value: CREATED_DATE.LAST_7 },
  { label: 'Last 14 days', value: CREATED_DATE.LAST_14 },
  { label: 'Last 30 days', value: CREATED_DATE.LAST_30 },
  { label: 'Last 60 days', value: CREATED_DATE.LAST_60 },
];

export const CREATED_DATE_OPTIONS_LABEL_30DAY = 'Last 30 days';

export const DEFAULT_CREATED_DATE = DEFAULT_CREATED_DATE_VALUE.LAST_30;

export const JOB_STAGES = {
  PRINTING: 'packJobPrinting',
  PACKING: 'packJobPacking',
  CHECKING: 'packJobChecking',
  DISTRIBUTION: 'packJobDistribution',
};

export const PACK_JOB_SKIPPING = {
  PROFILE_UPDATE: 0,
  IMCOMPLETE_SUPPLY: 1,
  OTHER: 2,
};

export const SKIP_OPTIONS = [
  { label: 'Profile Update', value: PACK_JOB_SKIPPING.PROFILE_UPDATE },
  { label: 'Incomplete Supply', value: PACK_JOB_SKIPPING.IMCOMPLETE_SUPPLY },
  { label: 'Other', value: PACK_JOB_SKIPPING.OTHER },
];

export const PPAK_VALUE = '3';

export const PACK_TYPE_LABEL = {
  ALL_TYPE: 'All',
  MYPAK_SOLID_PERF: 'MYPAK - SOLID & PERF',
  MYPAK_TRIFOLD: 'MYPAK - TRIFOLD',
  MEDICO: 'MEDICO PAK',
};

export const CLIENT_PACKTYPE = [
  { label: PACK_TYPE_LABEL.ALL_TYPE, value: FILTER_PACK_ALL },
  { label: PACK_TYPE_LABEL.MYPAK_SOLID_PERF, value: '0,0,1' },
  { label: PACK_TYPE_LABEL.MYPAK_TRIFOLD, value: '0,2' },
  { label: PACK_TYPE_LABEL.MEDICO, value: '2,3' },
  // { label: 'PPAK', value: '3,0' } MC-593015
];

export const MESSAGE_CODE = {
  NOT_ASSIGNED_MEDICATION: 70,
};

export const JOB_ACTION_ENUM = {
  PRINTING_PRINT_AND_PACK: 0,
  PRINTING_ROBOT_PACK: 1,
  PRINTING_DELETE_PACK: 2,
  PACKING_COMPLETE_PACK: 3,
  PACKING_CORRECTION: 4,
  PACKING_DELETE_PACK: 5,
  CHECKING_CONFIRM_PASS: 6,
  CHECKING_PACK_CORRECTION: 7,
  CHECKING_DELETE_PACK: 8,
  DISTRIBUTION_COMPLETE_PACK: 9,
  DISTRIBUTION_DELETE_PACK: 10,
  COMPLETED_REVERT_TO_DISTRIBUTION: 11,
  COMPLETED_DELETE_PACK: 12,
};
